/**
 * Nạp TOÀN BỘ một danh sách có phân trang cho ô chọn / bộ lọc.
 *
 * Ô chọn mà chỉ lấy trang đầu thì phần còn lại biến mất không một lời báo: trước 09/10/2026 ô chọn khách lấy 100 khách
 * mới tạo nhất, production có 171 khách và cả 107 khách China tạo sau khách Việt Nam, nên ô chọn khách của đơn mẫu / PI
 * chỉ còn khách China (khách báo không tìm được APIC).
 *
 * Phần thuần này không đụng mạng: `fetchPage` được truyền vào, để test được mà không cần máy chủ giả.
 */

/** Trần pageSize của API (`paginationSchema`) — mỗi lượt hỏi hết cỡ để ít vòng nhất. */
export const PICKER_PAGE_SIZE = 200;

export type PickerPageFetcher<T> = (page: number, pageSize: number) => Promise<{ data: T[]; total: number }>;

/** Gộp theo id: một bản ghi lỡ hiện ở hai trang (dữ liệu đổi giữa chừng) không thành hai dòng trong ô chọn. */
export async function collectPickerOptions<T extends { id: string }>(fetchPage: PickerPageFetcher<T>): Promise<T[]> {
  const byId = new Map<string, T>();
  for (let page = 1; ; page++) {
    const r = await fetchPage(page, PICKER_PAGE_SIZE);
    for (const row of r.data) byId.set(row.id, row);
    if (r.data.length < PICKER_PAGE_SIZE || byId.size >= r.total) break;
  }
  return [...byId.values()];
}
